module.exports = __webpack_public_path__ + "img/tab-bg.08ff4568.png";